import {
    useState,
} from "react";
import {
    Box,
    Text,
    Badge,
    SimpleGrid,
    Image,
    Flex,
    Grid,
    Dialog,
} from "@chakra-ui/react";
import {
    FileText,
} from "lucide-react";
import PdfIcon from "../../../assets/pdf.png"
import AppDrawer from "../../../components/AppDrawer";

const BASE_URL =
    process.env
        .REACT_APP_API_BASE_URL;

const ViewDriverDrawer = ({
    driver,
    open,
    onClose,
}) => {
        const [
    selectedMedia,
    setSelectedMedia,
] = useState(
    null
);
    if (!driver) return null;

    const user =
        driver.user ||
        driver;

    const profileImage =
        driver.documents?.find(
            doc =>
                doc.document_type ===
                "Profile Image"
        );


    const getStatusColor =
        status => {
            switch (
                status
            ) {
                case "Approved":
                    return "green";

                case "Pending":
                    return "orange";

                case "Rejected":
                    return "red";

                case "Suspended":
                    return "red";

                case "Active":
                    return "blue";

                case "Inactive":
                    return "yellow";

                default:
                    return "gray";
            }
        };
    const driverDocuments =
    driver.documents?.filter(
        doc =>
            ![
                "Blue Book",
                "Vehicle Image",
            ].includes(
                doc.document_type
            )
    ) || [];

    return (
        <>
        <AppDrawer
            open={open}
            onClose={
                onClose
            }
            title="Driver Details"
            width="600px"
        >
            <Box>
                <Flex
                    align="center"
                    gap={4}
                    mb={6}
                >
                    {profileImage && (
                       <Image
                            src={`${BASE_URL}/${profileImage.file_path}`}
                            w="90px"
                            h="90px"
                            borderRadius="full"
                            objectFit="cover"
                            cursor="pointer"
                            transition=".2s"
                            _hover={{
                                opacity: 0.9,
                            }}
                            onClick={() =>
                                setSelectedMedia(
                                    {
                                        src: `${BASE_URL}/${profileImage.file_path}`,
                                        title:
                                            "Profile Image",
                                    }
                                )
                            }
                        />
                    )}

                    <Box>
                        <Text
                            fontSize="24px"
                            fontWeight="700"
                            color="#1E293B"
                        >
                            {[
                                user.first_name,
                                user.middle_name,
                                user.last_name,
                            ]
                                .filter(
                                    Boolean
                                )
                                .join(
                                    " "
                                ) ||
                                user.username}
                        </Text>

                        <Text
                            color="gray.500"
                            fontSize="sm"
                        >
                            {
                                user.email
                            }
                        </Text>

                        <Flex
                            gap={2}
                            mt={2}
                        >
                           

                            {driver.driver_id && (
                                <Badge
                                    colorPalette={getStatusColor(
                                        driver.status
                                    )}
                                >
                                    {
                                        driver.status
                                    }
                                </Badge>
                            )}
                        </Flex>
                    </Box>
                </Flex>

                <Text
                    fontSize="11px"
                    fontWeight="600"
                    color="#64748B"
                    textTransform="uppercase"
                    mb={4}
                >
                    Driver Information
                </Text>

                <Grid
                    templateColumns="repeat(2,1fr)"
                    gap={4}
                    mb={8}
                >
                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            Username
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.username
                            }
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            Phone
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.phone_number
                            }
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            District
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.district ||
                                "-"
                            }
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            Village
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.village ||
                                "-"
                            }
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            ID Number
                        </Text>

                        <Text fontWeight="600">
                            {user.id_or_passport_number ||
                                "-"}
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            Postal Address
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.postal_address ||
                                "-"
                            }
                        </Text>
                    </Box>

                    <Box>
                        <Text
                            fontSize="12px"
                            color="gray.500"
                        >
                            Physical Address
                        </Text>

                        <Text fontWeight="600">
                            {
                                user.physical_address ||
                                "-"
                            }
                        </Text>
                    </Box>

                    {driver.driver_id && (
                        <>
                            <Box>
                                <Text
                                    fontSize="12px"
                                    color="gray.500"
                                >
                                    License Number
                                </Text>

                                <Text fontWeight="600">
                                    {
                                        driver.license_number
                                    }
                                </Text>
                            </Box>

                            <Box>
                                <Text
                                    fontSize="12px"
                                    color="gray.500"
                                >
                                    License Expiry
                                </Text>

                                <Text fontWeight="600">
                                    {
                                        driver.license_expiry_date
                                    }
                                </Text>
                            </Box>

                            <Box>
                                <Text
                                    fontSize="12px"
                                    color="gray.500"
                                >
                                    Route Preference
                                </Text>

                                <Text fontWeight="600">
                                    {
                                        driver.route_preference
                                    }
                                </Text>
                            </Box>

                            <Box>
                                <Text
                                    fontSize="12px"
                                    color="gray.500"
                                >
                                    Package Preference
                                </Text>

                                <Text fontWeight="600">
                                    {
                                        driver.package_preference
                                    }
                                </Text>
                            </Box>
                        </>
                    )}
                </Grid>

                {!!driverDocuments.length && (
                    <>
                        <Text
                            fontSize="11px"
                            fontWeight="600"
                            color="#64748B"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Documents
                        </Text>

                        <SimpleGrid
                            columns={2}
                            gap={3}
                        >
                           {driverDocuments.map(
                                doc => {

                                    const isImage =
                                        [
                                            "png",
                                            "jpg",
                                            "jpeg",
                                            "webp",
                                        ].includes(
                                            doc.file_extension?.toLowerCase()
                                        );

                                    return (
                                        <Box
                                            key={
                                                doc.document_id
                                            }
                                            border="1px solid"
                                            borderColor="#E2E8F0"
                                            borderRadius="10px"
                                            overflow="hidden"
                                            cursor="pointer"
                                            onClick={() =>
                                                setSelectedMedia(
                                                    {
                                                        src: `${BASE_URL}/${doc.file_path}`,
                                                        title:
                                                            doc.document_type,
                                                        extension:
                                                            doc.file_extension,
                                                    }
                                                )
                                            }
                                        >
                                            {isImage ? (
                                                <Image
                                                    src={`${BASE_URL}/${doc.file_path}`}
                                                    h="180px"
                                                    w="100%"
                                                    objectFit="cover"
                                                />
                                            ) : (
                                                <Flex
                                                    h="180px"
                                                    justify="center"
                                                    align="center"
                                                    bg="gray.50"
                                                    direction="column"
                                                    gap={2}
                                                >
                                                    <Image
                                                        src={PdfIcon}
                                                         h="80%"
                                                         w="80%"
                                                    />

                                                   
                                                </Flex>
                                            )}

                                            <Box p={3}>
                                                <Text
                                                    fontWeight="600"
                                                    fontSize="12px"
                                                >
                                                    {
                                                        doc.document_type
                                                    }
                                                </Text>

                                                <Text
                                                    fontSize="11px"
                                                    color="gray.500"
                                                >
                                                    {doc.file_path
                                                        ?.split("/")
                                                        .pop()}
                                                </Text>
                                            </Box>
                                        </Box>
                                    );
                                }
                            )}
                        </SimpleGrid>
                    </>
                )}
            </Box>
        </AppDrawer>
      <Dialog.Root
    open={
        !!selectedMedia
    }
    onOpenChange={(
        details
    ) => {
        if (
            !details.open
        ) {
            setSelectedMedia(
                null
            );
        }
    }}
>
    <Dialog.Backdrop />

    <Dialog.Positioner
        p={{
            base: 4,
            md: 6,
        }}
    >
        <Dialog.Content
            w="100%"
            maxW={{
                base: "95vw",
                sm: "600px",
                lg: "800px",
            }}
            maxH="90vh"
            bg="white"
            overflow="hidden"
            borderRadius={{
                base: "20px",
                md: "24px",
            }}
        >
            <Dialog.Header>
                <Dialog.Title
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                >
                    {
                        selectedMedia?.title
                    }
                </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body
                p={0}
                overflow="hidden"
            >
                {[
                    "png",
                    "jpg",
                    "jpeg",
                    "webp",
                ].includes(
                    selectedMedia?.extension?.toLowerCase()
                ) ? (
                    <Image
                        src={
                            selectedMedia?.src
                        }
                        w="100%"
                        maxH={{
                            base: "70vh",
                            md: "80vh",
                        }}
                        objectFit="contain"
                    />
                ) : (
                    <iframe
                        src={
                            selectedMedia?.src
                        }
                        title={
                            selectedMedia?.title
                        }
                        style={{
                            width: "100%",
                            height:
                                window.innerWidth < 768
                                    ? "70vh"
                                    : "80vh",
                            border: "none",
                        }}
                    />
                )}
            </Dialog.Body>
        </Dialog.Content>
    </Dialog.Positioner>
</Dialog.Root>
</>
    );
};

export default ViewDriverDrawer;